import _ from 'lodash'
import { apolloClient } from '@/graphql/apollo'
import { GET_ALL_IMPORTS_QUERY, GET_IMPORT_QUERY, CREATE_IMPORT_MUTATION, UPDATE_IMPORT_MUTATION, DELETE_IMPORT_MUTATION, EXPORT_MUTATION } from '@/graphql/queries/imports'
import { normalize } from 'normalizr'
import { importSchema, importsSchema } from '@/schema'

import { initStateMixin, gettersMixin, actionsMixin, mutationsMixin } from '@/mixins/crud/store'

const initState = () => {
  return _.cloneDeep(initStateMixin)
}

// initial state
const state = initState()

// getters
const getters = {
  ...gettersMixin
}

// actions
const actions = {
  ...actionsMixin,
  // loadAll: async ({ commit }, {force = false}) => {
  loadAll: async ({ commit }, { force, page }) => {
    force = force || false
    page = parseInt(page) || 1
    commit('setLoading', true, { root: true })

    const fetchPolicy = force ? 'network-only' : 'cache-first'
    const response = await apolloClient.query({ query: GET_ALL_IMPORTS_QUERY, variables: { page: page }, fetchPolicy: fetchPolicy })

    let normalizedData = normalize(response.data, importsSchema)
    commit('updateEntities', { normalizedData }, { root: true })
    commit('setLoading', false, { root: true })
  },
  loadById: async ({ commit }, id) => {
    let response = null

    const parsedId = parseInt(id)
    if (typeof(parsedId) == 'number' && parsedId > 0) {
      commit('setLoading', true, { root: true })

      response = await apolloClient.query({ query: GET_IMPORT_QUERY, variables: { id: parsedId } })
      const normalizedData = normalize(response.data, importSchema)
      commit('updateEntities', { normalizedData }, { root: true })

      commit('setLoading', false, { root: true })
    }

    return response
  },
  save: async ({ commit }, { id, form }) => {
    let response = null

    commit('setLoading', true, { root: true })
    if (id) {
      response = await apolloClient.mutate({ mutation: UPDATE_IMPORT_MUTATION, variables: {id: id, import: form}, context: { hasUpload: true } })
    } else {
      response = await apolloClient.mutate({ mutation: CREATE_IMPORT_MUTATION, variables: {import: form}, context: { hasUpload: true } })
      apolloClient.clearStore()
    }

    commit('setLoading', false, { root: true })

    if (response) {
      const normalizedData = normalize(response.data, importSchema)
      commit('updateEntities', { normalizedData }, { root: true })
    }

    return response
  },

  delete: async ({ commit }, ids) => {
    commit('setLoading', true, { root: true })

    const response = await apolloClient.mutate({ mutation: DELETE_IMPORT_MUTATION, variables: { ids: ids } })
    response.data.import.map(m => commit('removeEntity', m.id))
    apolloClient.clearStore()

    commit('setLoading', false, { root: true })

    return response
  },

  exportFile: async ({ commit }, format) => {
    commit('setLoading', true, { root: true })
    const response = await apolloClient.mutate({ mutation: EXPORT_MUTATION, variables: { format: format } })
    commit('setLoading', false, { root: true })

    return response
  }
}

// mutations
const mutations = {
  ...mutationsMixin
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
